<template>
  <section class="my-16">
    <v-container>
      <v-row no-gutters>
        <v-col
          cols="12"
          sm="6"
          class="text-center order-1"
          :class="{
            'order-sm-0': section.leftImage,
            'order-sm-1': !section.leftImage,
          }"
        >
          <div class="d-flex justify-center align-center full-parent">
            <vue-aos
              animation-class="animate__animated"
              :class="{
                animate__zoomInLeft: section.leftImage,
                animate__zoomInRight: !section.leftImage,
              }"
            >
              <v-img contain max-height="300" :src="imageURL"></v-img>
            </vue-aos>
          </div>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          class="pa-8 grey--text text--darken-1 order-0"
          :class="{
            'order-sm-1': section.leftImage,
            'order-sm-0': !section.leftImage,
          }"
        >
          <div class="d-flex justify-center align-center">
            <div>
              <vue-aos
                animation-class="animate__animated"
                :class="{
                  animate__zoomInRight: section.leftImage,
                  animate__zoomInLeft: !section.leftImage,
                }"
              >
                <h2
                  class="text-h4 mb-8 black--text"
                  v-text="section.title"
                ></h2>
              </vue-aos>
              <vue-aos
                animation-class="animate__animated"
                :class="{
                  animate__zoomInRight: section.leftImage,
                  animate__zoomInLeft: !section.leftImage,
                }"
              >
                <div v-html="$sanitize(section.content)"></div>
              </vue-aos>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import VueAos from "vue-aos";
import TipoSecaoEnum from "~/commons/enums/tipo-secao.enum";

export function Footer(
  options = {
    visible: true
  }
) {
  Object.defineProperty(this, "type", { get: () => TipoSecaoEnum.RODAPE });

  this.visible = options.visible;

  this.stringify = function () {
    return JSON.stringify({ ...this, type: TipoSecaoEnum.RODAPE });
  };
  this.toApi = function () {
    return {
      tipo: TipoSecaoEnum.RODAPE,
      indicadorSecao: TipoSecaoEnum.RODAPE,
      visible: this.visible,
    };
  };
}

export function Section(
  options = {
    menuTitle: "Menu",
    logoSrc: null,
    title: "Título",
    content: `Informação`,
    leftImage: true,
  }
) {
  Object.defineProperty(this, "type", { get: () => TipoSecaoEnum.SOBRE });

  this.menuTitle = options.menu || options.menuTitle;
  this.logoSrc = options.logoSrc || options.enderecoDaImagemDoLogotipo;
  this.title = options.titulo || options.title;
  this.content = options.conteudo || options.content;
  this.leftImage =
    typeof options.imagemNoLadoEsquerdo !== "undefined"
      ? options.imagemNoLadoEsquerdo
      : options.leftImage;

  this.isValid = function () {
    return this.title || this.content;
  };

  this.stringify = function () {
    return JSON.stringify({ ...this, type: TipoSecaoEnum.SOBRE });
  };

  this.toApi = function () {
    return {
      menu: this.menuTitle,
      logoSrc: this.logoSrc,
      titulo: this.title,
      conteudo: this.content,
      imagemNoLadoEsquerdo: this.leftImage,
      indicadorSecao: TipoSecaoEnum.SOBRE,
      tipo: TipoSecaoEnum.SOBRE,
    };
  };

  if (!this.isValid()) {
    throw new Error("Seção de conteúdo inválida.");
  }
}

export default {
  name: "LandingPageSection",
  components: { VueAos },
  props: {
    preview: {
      type: Boolean,
      required: false,
    },
    section: {
      type: Section,
      required: true,
      validator(value) {
        return value.isValid();
      },
    },
  },
  computed: {
    imageURL() {
      return URL.createObjectURL(this.section.logoSrc || new File([""], "image.png", { type: "image/png" }))
    },
  },
};
</script>